import React from "react";
import { FormattedMessage, FormattedNumber } from "react-intl";
import HighlightableText from "../../Common/HighlightableText.jsx";
import ImageOrFlag from "../../Common/MatchSideImageOrFlag.jsx";

const AchievementDetail = ({
  detail,
  sportsmen,
  achievement,
  team,
  marked,
  smallIcons,
  displaySquareBorder,
}) => (
  <div className="detail-achievement">
    <ImageOrFlag
      displaySquareBorder={displaySquareBorder}
      small={smallIcons}
      side={team}
    />
    <HighlightableText
      active={marked}
      className={
        detail.diffPoints < 0 ? "detail-achievement-sportsmen--negative" : ""
      }
    >
      {achievementText(detail, team, sportsmen, achievement)}
    </HighlightableText>
  </div>
);

const FormatDiffNumber = ({ value, children }) => (
  <FormattedNumber value={value}>
    {(valueStr) => children(`${value > 0 ? "+" : ""}${valueStr}`)}
  </FormattedNumber>
);

const FormatValues = ({ detail, children }) => (
  <FormattedMessage id="generic.pointsAbbr">
    {(pointsAbbr) => (
      <FormatDiffNumber value={detail.diffPoints}>
        {(diffPoints) => (
          <FormatDiffNumber value={detail.diffTimes}>
            {(diffTimes) => children({ pointsAbbr, diffPoints, diffTimes })}
          </FormatDiffNumber>
        )}
      </FormatDiffNumber>
    )}
  </FormattedMessage>
);

const achievementText = (detail, team, sportsmen, achievement) => {
  let sportsmanName = sportsmen.name;
  switch (achievement.valueType) {
    case "BOOL":
      return (
        <FormatValues detail={detail}>
          {({ pointsAbbr, diffPoints }) => (
            <span>
              {`${sportsmanName} ${achievement.name}: ${diffPoints} ${pointsAbbr}`}
            </span>
          )}
        </FormatValues>
      );

    default:
      return (
        <FormatValues detail={detail}>
          {({ pointsAbbr, diffPoints, diffTimes }) => (
            <span>
              {`${sportsmanName} ${achievement.name}: ${diffTimes} (${diffPoints} ${pointsAbbr})`}
            </span>
          )}
        </FormatValues>
      );
  }
};

export default AchievementDetail;
